import { z } from "zod";

export const useTransferServiceProviderSchema = () => {
  return z.object({
    transferToJointBillServiceId: z.number(),
  });
};

export type TTransferServiceProviderSchema = z.infer<
  ReturnType<typeof useTransferServiceProviderSchema>
>;
